export const maxLength = (value: string, length = 120): string => {
	if (!value) {
		return '';
	}

	if (value.length > length) {
		return value.substring(0, length) + '...';
	}

	return value;
};
